import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import $ from "jquery";
import Loader from 'react-loader-spinner';
const onRowClick = (state, rowInfo, column, instance) => {
  return {
    onClick: e => {
      console.log('A Td Element was clicked!')
      console.log('it produced this event:', e)
      console.log('It was in this column:', column)
      console.log('It was in this row:', rowInfo)
      console.log('It was in this table instance:', instance)
    }
  }
}
class AdvancedCustomSettings extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      data: [{
        agentPropertyName: '',
        description: '',
        agentPropertyValue: ''

      }],
      editedagentPropertyName: '-1',
      editImageSrc: './assets/images/edit2.png',
      contentEditable: "false",
      editId: '-1',
      successResp: false,
      hideResetPopup: false,
      propertyName: '',
      planAmount: 0
    }
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.dialogClose = () => {
      this.setState({
        hideResetPopup: false,
      });
    };

    this.settings = { effect: 'Zoom', duration: 600, delay: 0 };

    //for reset dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': (props) => {
        this.resetAdvancedCustomProperty(this.state.propsId)
      }
    },
    {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ hideResetPopup: false });
      }
    }];
  }

  notifyEmptyBooleanFields() {
    toast.dismiss();
    this.state.editId = '0';
    toast(<b>please give yes or no</b>, {
      position: "top-center",


    });

  }
  notifyEmptyFields() {
    toast.dismiss();
    this.state.editId = '0';
    toast(<b>please fill field </b>, {
      position: "top-center",

    });

  }
  fetchPropertiesApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var propertyController = this;
    $.ajax({
      url: "/api/agent-properties",
      async: false,
      method: 'GET',
      data: { "projectId": projectId },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          propertyController.state.data = res.result;
          propertyController.state.successResp = true;
          propertyController.state.editId = '-1';
          propertyController.setState(propertyController.state);

        } else {
          propertyController.setState({
            successResp: false
          });
          propertyController.notifyFailToCreate(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  refreshPropertyData = () => {
    this.fetchPropertiesApi();
  }

  markAsBeingEdited(agentPropertyName) {
    this.state.editedagentPropertyName = agentPropertyName;
    this.state.editId = '0';
    var stateObj = this.state;
    this.setState(stateObj);

  }

  validateCells(agentPropertyName, agentPropertyValue, description) {
    if (agentPropertyName != "WEB_VIEW_KEY") {
      if (description.includes("yes/no")) {
        if (agentPropertyValue.toLowerCase() == "yes" || agentPropertyValue.toLowerCase() == "no") {
          return true;
        } else {
          this.notifyEmptyBooleanFields();
          return false;
        }

      } else if (agentPropertyName == "WALLET_REFILL_AMOUNT") {
        const regex = /^[0-9\b]+$/;
        if (regex.test(agentPropertyValue)) {
          if (Number(this.state.planAmount) < Number(agentPropertyValue)) {
            return true;
          } else {
            this.notifyWarning("Please enter a value greater than the plan amount");
            return false;
          }
        } else {
          this.notifyWarning("Please enter a valid value");
          return false;
        }
      }

      else {
        if (agentPropertyValue == "") {

          this.notifyEmptyFields();
          return false;
        } else {
          return true;
        }

      }
    } else {
      return true;
    }
  }

  notifyWarning = (message) => {
    toast.dismiss();
    this.state.editId = '0';
    toast(<b><img src="./assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;{message}</b>, {
      position: "top-center",
    });
  }
  notifyFailToCreate(falseResult) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseResult}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  notifyProperyUpdatedSuccess(propertyName) {
    toast.dismiss();
    this.state.editId = '0';
    this.setState(this.state);
    propertyName = propertyName.split("_").join(" ");;
    toast(<b style={{ color: "#A9A9A9" }}><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{propertyName} property updated Successfully</b>, {
      position: "top-center",
    });

  }

  notifyResetSuccess(propertyName) {
    toast.dismiss();
    propertyName = propertyName.split("_").join(" ");;
    toast(<b style={{ color: "#A9A9A9" }}><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{propertyName} property has been reset successfully</b>, {
      position: "top-center",
    });

  }

  saveAdvanceCustomSetingsApi(props, e) {
    var advancedCustomController = this;
    props.original.agentPropertyName = document.getElementById("agentPropertyName" + props.index).innerText.trim();
    props.original.agentPropertyValue = document.getElementById("agentPropertyValue" + props.index).innerText.trim();
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.agentPropertyName, props.original.agentPropertyValue, props.original.description);
    if (validateResult == true) {
      var updatedData = {
        "projectId": localStorage.getItem("currentProjectId"),

        agentPropertyName: props.original.agentPropertyName,
        agentPropertyValue: props.original.agentPropertyValue
      };

      $.ajax({
        url: "/api/agent-properties",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            advancedCustomController.state.editId = '-1';
            advancedCustomController.state.editedagentPropertyName = '-1';
            advancedCustomController.notifyProperyUpdatedSuccess(updatedData.agentPropertyName);
            advancedCustomController.fetchPropertiesApi();
            advancedCustomController.setState(this.state);
          } else {
            advancedCustomController.notifyFailToCreate(res.result);


          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }

      })
    }

  }

  resetChange = (props, e) => {
    props.original.agentPropertyValue = document.getElementById("agentPropertyValue" + props.index).innerText;
    this.state.hideResetPopup = true;
    this.state.propertyName = props.original.agentPropertyName;
    this.setState(this.state);
  }
  editCell(props, e) {
    this.markAsBeingEdited(props.original.agentPropertyName);
  }

  componentDidMount() {
    var thisController = this;
    setTimeout(() => {
      thisController.fetchPropertiesApi();
      thisController.fetchPlanAmountApi();
    }, 300);
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchPropertiesApi(event.projectId);
      thisController.fetchPlanAmountApi(event.projectId);
    });
  }

  resetAdvancedCustomProperty = () => {
    var advancedCustomController = this;
    var data = {
      "projectId": localStorage.getItem("currentProjectId"),
      "agentPropertyName": advancedCustomController.state.propertyName,
      "agentPropertyValue": ''
    }
    $.ajax({
      url: "/api/agent-properties",
      async: false,
      method: 'DELETE',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data),
      processData: false,
      success: function (res) {
        if (res.success === true) {
          advancedCustomController.state.hideResetPopup = false;
          advancedCustomController.setState(advancedCustomController.state);
          advancedCustomController.fetchPropertiesApi();
          advancedCustomController.notifyResetSuccess(advancedCustomController.state.propertyName);
        } else {
          advancedCustomController.notifyFailToCreate(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    })
  }

  fetchPlanAmountApi = (projectId) => {
    var advancedCustomController = this;
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    $.ajax({
      url: "/api/get-plan-amount",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId,
        "billingInterval": 'MONTHLY_PLAN'
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          advancedCustomController.state.planAmount = res.result.planAmount;
          advancedCustomController.setState(advancedCustomController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  render() {
    const { data } = this.state
    this.columns = [
      {
        Header: <b >Property Name</b>,
        accessor: 'agentPropertyName',
        minWidth: 20,
        sortable: false,
        Cell: props => (<div
          Align="left"
          type="text" id={"agentPropertyName" + props.index}

        >{props.original.agentPropertyName}</div>
        )



      },
      {
        Header: <b>Description</b>,
        accessor: 'description',
        minWidth: 27,
        sortable: false,
        Cell: props => (<div
          Align="left" className="textarea"
          contentEditable={false}
          type="text" id={"description" + props.index}
        >{props.original.description}</div>

        )



      }, {
        Header: <b>Value</b>,
        accessor: 'agentPropertyValue',
        minWidth: 22,
        sortable: false,
        Cell: props =>
        (<div
          Align="left" className="input"
          style={{ padding: "8px", borderBottom: 'none', border: (props.original.agentPropertyName == this.state.editedagentPropertyName && this.state.editId == '0' && props.original.agentPropertyName != "WEB_VIEW_KEY") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.agentPropertyName == this.state.editedagentPropertyName && this.state.editId == '0') ? '2px' : 'none', paddingLeft: '2px' }}
          contentEditable={(props.original.agentPropertyName == this.state.editedagentPropertyName) && this.state.editId === '0' && props.original.agentPropertyName != "WEB_VIEW_KEY"}
          suppressContentEditableWarning
          type="text" id={"agentPropertyValue" + props.index} name="propertyValue"
        >{props.original.agentPropertyValue}</div>)
      },
      {
        Header: <b>Actions</b>,
        minWidth: 8,
        Cell: props => (
          <div Align="left">

            {/* Edit/Save Button */}
            <button title={(props.original.agentPropertyName == this.state.editedagentPropertyName && this.state.editId == '0') ? "save" : "edit"} style={{ backgroundColor: "#ffffff", border: "none" }}>
              <img className="img-responsive" id="editORsave" style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                src={(props.original.agentPropertyName == this.state.editedagentPropertyName && this.state.editId == '0') ? this.saveImageSrc : this.editImageSrc}
                onClick={(e) => {
                  (props.original.agentPropertyName == this.state.editedagentPropertyName) ? this.saveAdvanceCustomSetingsApi(props, e)
                    :
                    this.editCell(props, e);

                }}
              />
            </button>

            {/* Reset */}
            <button className="btn2 table-action-button"
              onClick={(e) =>
                this.resetChange(props, e)
              }
            >Reset
            </button>

          </div>

        )
      }
    ]
    return (
      <div  >
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: 'center' }}
        />
        {/* for reactToast */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />

        {/* for reactTable */}
        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
        <div className="wrapper" style={{ display: this.state.successResp ? 'block' : 'none' }}>
          <div className="container-fluid" style={{ marginTop: "0px" }}>
            < ToastContainer className="Toast-at-center" />
            <div className="row">
              <div className="col-sm-5">
                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Advanced Custom Settings</h6>


                <br />
              </div>
              <div className="col-sm-7" Align="right">
                <button className="btn action-button"
                  title="Refresh" onClick={this.refreshPropertyData}>
                  <img src="./assets/images/refresh_white_24dp.png" />
                </button>
              </div>
              <div className="col-lg-12 ">

                <div className="card">

                  <div >
                    <ReactTable id='reactTable'
                      data={data}
                      columns={this.columns}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}

                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*Dialog Component For Reset Confirmation*/}
        <DialogComponent width='400px' animationSettings={this.settings} style={{ position: 'fixed' }}
          header='Advanced Custom Settings' showCloseIcon={true} buttons={this.buttons}
          ref={dialog => this.dialogInstance = dialog}
          visible={this.state.hideResetPopup} close={this.dialogClose}>
          <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;Do you want to reset?<br />Note: Press 'Yes' to reset or press 'No' to decline.</DialogComponent>


      </div>
    )
  }
}
export default AdvancedCustomSettings;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/AdvancedCustomSettings.js